import { render, staticRenderFns } from "./SaturationBoard.vue?vue&type=template&id=47c155f9&scoped=true"
import script from "./SaturationBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaturationBoard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SaturationBoard.vue?vue&type=style&index=0&id=47c155f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c155f9",
  null
  
)

export default component.exports